<template>
  <div class="login">
    <div class="container">
      <div class="login-body" style="border-radius: 8px">
        <h3 class="login-title">登陆</h3>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="login()" status-icon>
          <el-form-item prop="username">
            <el-input v-model="dataForm.username" placeholder="用户名">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="dataForm.password" type="password" placeholder="密码">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="login_bit">
          <el-button type="primary" @click="login()" class="w-percent-100">登陆</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      dataForm: {
        username: "",
        password: "",
        uuid: '',
        captcha: '123123'
      },
    };
  },
  methods: {
    async login() {
      let type = false
      this.$refs.dataForm.validate((valid) => {
        if (!valid) type = true
      });
      if(type) return
      this.dataForm.uuid = this.dataForm.username
      let { data : { code, data }} = await this.$http.post('/login', this.dataForm)
      if(code != 0) return this.$message.warning('账号或密码错误')
      this.$message.success('登陆成功!')
      localStorage.setItem('token', data.token)
      this.$router.push('/profile')
    },
  },
  computed: {
    dataRule() {
      return {
        username: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "必填项不能为空",
            trigger: "blur",
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  width: 100%;
  background-color: #f0f0f0;
  .login_bit {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .login-body {
    padding: 30px 0;
    width: 500px;
    margin: auto;
    .login-title {
      text-align: center;
      line-height: 4;
    }
  }
}
</style>